import { motion } from "motion/react";

export function LStatsSection() {
  return (
    <section className="py-16 bg-[#0a0a0a] border-y border-[#9B87F5]/10">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <pre className="font-mono text-[#9B87F5] text-[10px] sm:text-xs mb-8 inline-block">
            {`
╔══════════════════════════════════════════════════════════════════════════════╗
║                                                                              ║
║     "There are many types of monsters in this world...                       ║
║      Monsters who cause trouble without showing themselves,                  ║
║      monsters who abduct children, monsters who devour dreams,               ║
║      monsters who suck blood, and monsters who always tell lies.             ║
║                                                                              ║
║      Lying monsters are a real nuisance. They are much more cunning          ║
║      than other monsters. They pose as humans even though they have          ║
║      no understanding of the human heart.                                    ║
║                                                                              ║
║      They eat even though they've never experienced hunger.                  ║
║      They study even though they have no interest in academics.              ║
║      They seek friendship even though they do not know how to love.          ║
║                                                                              ║
║      If I were to encounter such monsters, I would likely be eaten           ║
║      by them... because in truth, I am that monster."                        ║
║                                                                              ║
║                                                              — L Lawliet     ║
║                                                                              ║
╚══════════════════════════════════════════════════════════════════════════════╝
`}
          </pre>
        </motion.div>

        {/* Stats row */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-8"
        >
          <div className="text-center p-4 bg-[#1A1F2C]/30 rounded-lg border border-[#9B87F5]/10">
            <pre className="font-mono text-[#9B87F5] text-xs mb-2">
              {`┌───────┐
│ 99.9% │
└───────┘`}
            </pre>
            <p className="text-[#8E9196] font-mono text-sm">UPTIME</p>
          </div>
          <div className="text-center p-4 bg-[#1A1F2C]/30 rounded-lg border border-[#9B87F5]/10">
            <pre className="font-mono text-[#9B87F5] text-xs mb-2">
              {`┌───────┐
│  <1s  │
└───────┘`}
            </pre>
            <p className="text-[#8E9196] font-mono text-sm">REDIRECT</p>
          </div>
          <div className="text-center p-4 bg-[#1A1F2C]/30 rounded-lg border border-[#9B87F5]/10">
            <pre className="font-mono text-[#9B87F5] text-xs mb-2">
              {`┌───────┐
│  ∞    │
└───────┘`}
            </pre>
            <p className="text-[#8E9196] font-mono text-sm">LINKS</p>
          </div>
          <div className="text-center p-4 bg-[#1A1F2C]/30 rounded-lg border border-[#9B87F5]/10">
            <pre className="font-mono text-[#9B87F5] text-xs mb-2">
              {`┌───────┐
│  $0   │
└───────┘`}
            </pre>
            <p className="text-[#8E9196] font-mono text-sm">COST</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
